import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import TextField from 'material-ui/TextField';
import Toggle from 'material-ui/Toggle';
import { Tabs, Tab } from 'material-ui/Tabs';

import { saveTask } from '../../store/modules/task';
import classes from './SideBarTasks.scss';
import TaskList from '../TaskList';

const mapActionCreators = {
  saveTask,
};

const mapStateToProps = state => ({
  task: state.task.tasks[state.task.current],
  tasks: state.task.tasks,
  fetching: state.task.fetching,
  current: state.task.current,
  login: state.login,
});

class SideBarTasks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newTask: '',
      hideCompleted: true,
    };
  }

  createNewTask = event => {
    this.setState({ newTask: event.target.value });
    if (event.keyCode === 13) {
      this.props.saveTask({ title: this.state.newTask });
      this.setState({ newTask: '' });

      this.newTask.value = '';
      this.newTask.input.value = '';

      this.newDelegatedTask.value = '';
      this.newDelegatedTask.input.value = '';
    }
  };

  toggleCompleted = () => {
    // // console.log('toggling completed')
    this.setState({
      hideCompleted: !this.state.hideCompleted,
    });
  };

  render() {
    const tasks = [];
    const delegatedTasks = [];

    const sortedTasks = _.orderBy(this.props.tasks, ['due_date'], ['desc']);

    _.forOwn(sortedTasks, data => {
      if (typeof data !== 'undefined' && data.deleted_at === null) {
        if (data.assignee_id === this.props.login.staff.id) {
          if (
            (!data.is_done && this.state.hideCompleted) ||
            (data.is_done && !this.state.hideCompleted)
          ) {
            tasks.push(data);
          }
        } else if (
          data.creator_id === this.props.login.staff.id &&
          data.assignee_id !== this.props.login.staff.id
        ) {
          if (
            (!data.is_done && this.state.hideCompleted) ||
            (data.is_done && !this.state.hideCompleted)
          ) {
            delegatedTasks.push(data);
          }
        }
      }
    });

    return (
      <Tabs
        className={classes.tabs}
        contentContainerClassName={classes.tabscontainer}
        tabItemContainerStyle={{
          backgroundColor: '#fafafa',
          height: 48,
          minHeight: 48,
        }}
      >
        <Tab
          label={`Meine Aufgaben (${tasks.length})`}
          className={classes.tab}
          style={{ color: '#4a4a4a', height: 36 }}
        >
          <section className={classes.header}>
            <Toggle
              label="Nur abgeschlossene Aufgaben anzeigen"
              defaultToggled={!this.state.hideCompleted}
              onToggle={this.toggleCompleted}
              labelStyle={{ fontSize: '12px' }}
            />
          </section>
          <section className={classes.taskSection}>
            <TaskList tasks={tasks} showFutureDates showNullDueDates />
          </section>
          <section className={classes.newTask}>
            <TextField
              ref={c => {
                this.newTask = c;
              }}
              hintText="Bspw. Rechtsanwalt anrufen"
              floatingLabelText="Neue Aufgabe erstellen"
              onKeyUp={this.createNewTask}
            />
          </section>
        </Tab>
        <Tab
          label={`Vergebene Aufgaben (${delegatedTasks.length})`}
          className={classes.tab}
          style={{ color: '#4a4a4a', height: 36 }}
        >
          <section className={classes.header}>
            <Toggle
              label="Nur abgeschlossene Aufgaben anzeigen"
              defaultToggled={!this.state.hideCompleted}
              onToggle={this.toggleCompleted}
              labelStyle={{ fontSize: '12px' }}
            />
          </section>
          <section className={classes.taskSection}>
            <TaskList tasks={delegatedTasks} showFutureDates showNullDueDates />
          </section>
          <section className={classes.newTask}>
            <TextField
              ref={c => {
                this.newDelegatedTask = c;
              }}
              hintText="Bspw. Rechtsanwalt anrufen"
              floatingLabelText="Neue Aufgabe erstellen"
              onKeyUp={this.createNewTask}
            />
          </section>
        </Tab>
      </Tabs>
    );
  }
}

SideBarTasks.propTypes = {
  saveTask: PropTypes.func,
};

export default connect(mapStateToProps, mapActionCreators)(SideBarTasks);



// WEBPACK FOOTER //
// ./src/components/SideBarTasks/SideBarTasks.js